module.exports = __webpack_public_path__ + "static/top_en_pc-320d5f94c957a35bb68213cca67a7190.jpg";